import React from "react";

import LoaderElement from "../LoaderElement";

const SeeAllVariantLoader = (): JSX.Element => {
  return <LoaderElement height={47} width={95} />;
};

export default SeeAllVariantLoader;
